import './app.scss';
import angular from 'angular';
import ngAnimate from 'angular-animate';
import ngSanitize from 'angular-sanitize';
import ngMessages from 'angular-messages';
import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
import uiGrid from 'angular-ui-grid';
import 'ui-select';


import { routeConfig } from './app.config';
import AppComponent from './app.component';
import constants from './app.constant';
import events from './app.event';
// import setupGAnalytics from './app.ga.js';
import Auth from '../components/auth';
import AsideMenu from '../components/aside-menu';
import Navbar from '../components/navbar';
import AsDate from '../components/as-date';
import validFile from '../components/valid-file';
import BeforeBottom from '../components/before-bottom';
import CheckOverflow from '../components/check-overflow';
import ScrollToBottom from '../components/scroll-to-bottom';
import UpdateTitle from '../components/update-title';
import GoogleAnalytics from '../components/google-analytics';
import CommentSection from '../components/comment-section';
import SubcaseCommentSection from '../components/subcase-comment-section';
import FileUpload from '../components/file-upload';
import FileList from '../components/file-list';
import CifShareService from '../components/cif-share';
import TemplateSaveService from '../components/template-save';
import StateChange from '../components/state-change';
import StateChangeService from '../components/state-change-modal';
import SubCaseStateChangeService from '../components/subcase-state-change-modal';
import CaseCheckService from '../components/case-check-modal';
import AllocateSubcaseService from '../components/allocate-subcase-modal';
import iframeOnLoad from '../components/iframe-onload';
import compile from '../components/compile';
import Spinner from '../components/spinner';
import RemoveHtmlTag from '../components/remove-html-tag';
import OAuth from './oauth';
import FourOFour from './four-o-four';
import FourOThree from './four-o-three';
import ThankYou from './thank-you';
import Subscription from './subscription';
import Main from './main';
import Dashboard from './dashboard';
import Cases from './cases';
import Reports from './reports';
import SidebarComponent from './reports/sidebar';
import Public from './public';
import * as c3 from 'c3';

/* eslint-disable angular/window-service */
window.c3 = c3;

// setupGAnalytics('UA-52116787-29');  // Google Analytics

angular
  .module('verifyApp', [
    ngAnimate, ngSanitize, uiRouter, uiBootstrap, ngMessages, AsideMenu, Navbar,
    constants, Auth, BeforeBottom, UpdateTitle, OAuth, Main, FourOFour, validFile,
    GoogleAnalytics, Subscription, FourOThree, Dashboard, Cases, CommentSection,
    FileUpload, FileList, CifShareService, TemplateSaveService, StateChange,
    StateChangeService, Public, ThankYou, ScrollToBottom, Spinner, AsDate,
    CaseCheckService, RemoveHtmlTag, AllocateSubcaseService, CheckOverflow,
    SubcaseCommentSection, compile, SubCaseStateChangeService, Reports, SidebarComponent,
    iframeOnLoad, 'ui.select', uiGrid,
  ])
  .component('verifyApp', AppComponent)
  .config(routeConfig)
  .run(events);

angular
  .element(document)
  .ready(() => {
    angular.bootstrap(document, ['verifyApp'], {
      strictDi: true,
    });
  });



// WEBPACK FOOTER //
// ./client/app/app.js